













































































































































import { Component, Prop, Mixins } from "vue-property-decorator";

import EthService from "@/api/web3/eth";
import CurrencyMixin from "@/mixins/currency";

import EventBus, { ACTIONS } from "@/event-bus";

import ModalRewards from "@/components/modal/ModalRewards.vue";
import ModalStake from "@/components/modal/ModalStake.vue";

import BN from "bn.js";
import { toBN } from "@/lib/web3x-es/utils";

@Component({
  components: {
    ModalRewards,
    ModalStake,
  },
})
export default class MyStaking extends Mixins(CurrencyMixin) {
  @Prop(Object) private stakingManager!: any;
  @Prop(Object) private reserveToken!: any;
  @Prop(Number) private tokenPrice!: any;

  private address = "";
  private chain = "";

  private totalStaked = 0;
  private walletBalance = 0;
  private claimableRewards = 0;

  private showStakeModal = false;
  private showRewardsModal = false;
  private showModalSpinner = false;

  // Props for Rewards (Claim/Restake) modal
  private modalRewardsType = "";

  // Props for Stake/Unstake modal
  private modalAction = "";
  private modalDescription = "";

  //
  private balanceUpdateTimer: any = null;

  get isConnected() {
    return this.address;
  }

  get supportedNetwork() {
    if (
      location.hostname.includes("testnet") ||
      location.hostname.includes("localhost") ||
      location.hostname.includes("vercel.app") // preview
    ) {
      return "mumbai";
    }
    return "matic";
  }

  get isValidNetwork() {
    return this.chain === this.supportedNetwork;
  }

  private openWalletModal() {
    this.$emit("open-wallet-modal");
  }

  private openStakeModal() {
    this.openStakingModal("stake");
  }

  private openUnstakeModal() {
    this.openStakingModal("unstake");
  }

  private openClaimModal() {
    this.openRewardsModal("claim");
  }

  private openRestakeModal() {
    this.openRewardsModal("restake");
  }

  private openStakingModal(type: string) {
    if (type.toLowerCase() === "stake") {
      this.modalAction = type;
      this.modalDescription = "Stake your TSX";
    }

    if (type.toLowerCase() === "unstake") {
      this.modalAction = type;
      this.modalDescription = "Unstake your TSX";
    }

    this.showStakeModal = true;
  }

  private openRewardsModal(type: string) {
    if (type.toLowerCase() === "claim") {
      this.modalRewardsType = type;
    }

    if (type.toLowerCase() === "restake") {
      this.modalRewardsType = type;
    }

    this.showRewardsModal = true;
  }

  private closeStakeModal() {
    this.showStakeModal = false;
  }

  private closeRewardsModal() {
    this.showRewardsModal = false;
  }

  private shortenAddress(address: string) {
    return `${address.substring(0, 6)}...${address.substring(36)}`;
  }

  private beforeDestroy() {
    clearTimeout(this.balanceUpdateTimer);
  }

  private async mounted() {
    const updateInfo = () => {
      this.updateWalletValues();

      clearTimeout(this.balanceUpdateTimer);
      this.balanceUpdateTimer = setTimeout(updateInfo, 60000);
    };

    EventBus.$on(ACTIONS.ETH_UPDATE_ACCOUNTS, () => {
      updateInfo();
    });

    EventBus.$on(ACTIONS.ETH_WALLET_TX, () => {
      updateInfo();
    });
  }

  private async updateWalletValues() {
    this.address = EthService.getAddress();
    this.chain = EthService.getChain();

    if (this.address) {
      [this.walletBalance, this.totalStaked, this.claimableRewards] =
        await Promise.all([
          this.reserveToken.balanceOf(this.address),
          this.stakingManager.totalStaked(this.address),
          this.stakingManager.claimableRewards(this.address),
        ]);
    }
  }

  private async sendTx(type: string, txParams: any) {
    const txHash = await EthService.sendTransaction(txParams);
    const rcpt = await EthService.waitTxReceipt(txHash, 500);

    console.debug(`${type}() - hash: `, txHash);
    console.debug(`${type}() - rcpt: `, rcpt);

    if (!rcpt.status) {
      throw new Error("Receipt status is false");
    }
  }

  private async stake(weiAmount: BN) {
    this.showModalSpinner = true;

    try {
      // Get the amount that was already approved for the tx
      const allowance = toBN(
        await this.reserveToken.allowance(
          this.address,
          this.stakingManager.getAddress()
        )
      );

      const txParams: any = {};

      // Calculate the extra allowance needed for the amount in this tx.
      // If it's greater than 0, ask for approval.
      const missingAllowance = weiAmount.sub(allowance);

      if (missingAllowance.gt(toBN(0))) {
        txParams.to = this.reserveToken.getAddress();
        txParams.data = this.reserveToken.approve(
          this.stakingManager.getAddress(),
          weiAmount
        );

        await this.sendTx("approve", txParams);
      }

      // approval OK, call to stake
      txParams.to = this.stakingManager.getAddress();
      txParams.data = this.stakingManager.stake(weiAmount);

      await this.sendTx("stake", txParams);

      EventBus.$emit(ACTIONS.ETH_WALLET_TX);
      this.closeStakeModal();
    } catch (err) {
      console.error(err);

      /* EventBus.$emit(ACTIONS.FAILED_DEPOSIT, {
        action: "error",
        msg: i18n.t("views.snackbar.error.failed_deposit"),
      }); */
    }
    this.showModalSpinner = false;
  }

  private async unstake(weiAmount: BN) {
    this.showModalSpinner = true;
    try {
      const txParams: any = {
        to: this.stakingManager.getAddress(),
        data: this.stakingManager.unstake(weiAmount),
      };

      await this.sendTx("unstake", txParams);

      EventBus.$emit(ACTIONS.ETH_WALLET_TX);
      this.closeStakeModal();
    } catch (err) {
      console.error(err);

      /* EventBus.$emit(ACTIONS.FAILED_DEPOSIT, {
        action: "error",
        msg: i18n.t("views.snackbar.error.failed_deposit"),
      }); */
    }
    this.showModalSpinner = false;
  }

  private async claim() {
    this.showModalSpinner = true;
    try {
      const txParams: any = {
        to: this.stakingManager.getAddress(),
        data: this.stakingManager.claim(),
      };

      await this.sendTx("claim", txParams);

      EventBus.$emit(ACTIONS.ETH_WALLET_TX);
      this.closeRewardsModal();
    } catch (err) {
      console.error(err);
      /* EventBus.$emit(ACTIONS.FAILED_DEPOSIT, {
        action: "error",
        msg: i18n.t("views.snackbar.error.failed_deposit"),
      }); */
    }
    this.showModalSpinner = false;
  }
}
